import { PencilIcon } from "lucide-react";
import { useState } from "react";
import { store } from "../../services/service";
import { MODIFIER_STATUT_MAINTENANCE } from "../../Utils/constant";
import { checkTagValidity } from "../../Utils/Utils";

export const StatusMaintenanceModal = ({ item, onStatusUpdate }) => {
  const [newStatus, setNewStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [raison, setRaison] = useState("");
  const [msg, setMsg] = useState("");
  const modalId = `status-modal-${item?.id}`;

  const handleUpdateStatus = async () => {
    setMsg("");
    if (!newStatus) {
      setMsg("Veuillez sélectionner un nouveau statut");
      return;
    }

    setIsUpdating(true);
    try {
      const response = await store(
        `${MODIFIER_STATUT_MAINTENANCE}?id=${item.id}&statut=${newStatus}&raison=${raison}`,
        "application/json",
        {},
      );

      if (response.status === 200) {
        document.getElementById(modalId).close();
        setNewStatus("");
        onStatusUpdate?.();
      }
    } catch (err) {
      alert("Erreur lors de la modification du statut");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleClose = () => {
    document.getElementById(modalId).close();
    setNewStatus("");
  };

  if (!checkTagValidity("MODIFIER_STATUT_REMONTEE")) {
    return null;
  }

  return (
    <>
      {/* Bouton de modification */}
      <button
        onClick={() => {
          setNewStatus("");
          document.getElementById(modalId).showModal();
        }}
        className="flex items-center px-3 py-2 bg-black text-white text-xs rounded-lg font-medium transition-colors hover:bg-gray-800"
      >
        <PencilIcon className="w-3 h-3 mr-1" />
        Modifier le statut
      </button>

      {/* Modale */}
      <dialog id={modalId} className="modal">
        <div className="modal-box">
          <h2 className="font-bold text-lg mb-4">
            Modifier le statut de maintenance
          </h2>

          <span className="text-sm text-red-500">{msg}</span>
          {item && (
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <p className="text-sm">
                <strong>ID Maintenance:</strong> {item.id}
              </p>
              <p className="text-sm mt-2">
                <strong>Client:</strong> {item.nomPrenomsClient}
              </p>
              <p className="text-sm mt-2">
                <strong>Statut actuel:</strong>{" "}
                <span className="font-semibold">
                  {item.statut.replace(/_/g, " ").toLowerCase()}
                </span>
              </p>
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">
              Nouveau statut<span className="text-red-400">*</span>
            </label>
            <select
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              className="select select-bordered w-full"
            >
              <option value="">Sélectionner un statut</option>
              <option value="EN_ATTENTE_DE_TRAITEMENT">En attente</option>
              <option value="RESOLUE">Résolue</option>
              <option value="FERMEE">Non résolue</option>
            </select>
          </div>

          {newStatus === "FERMEE" && (
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Raison<span className="text-red-400">*</span>
              </label>
              <textarea
                value={raison}
                onChange={(e) => setRaison(e.target.value)}
                className="textarea textarea-bordered w-full"
                placeholder="Raison"
              />
            </div>
          )}

          <div className="modal-action">
            <button
              type="button"
              className="px-4 py-2.5 bg-main border-main text-gray-800 rounded-lg text-sm"
              disabled={isUpdating}
              onClick={handleUpdateStatus}
            >
              {isUpdating ? "Modification..." : "Modifier"}
            </button>
            <button
              type="button"
              className="px-4 py-2.5 bg-gray-200 text-gray-800 rounded-lg text-sm"
              onClick={handleClose}
            >
              Annuler
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
};
